import { UserActionCardController } from './user-action-card.controller'

function userActionCard () {
  return {
    restrict: 'E',
    scope: {
      action: '='
    },
    templateUrl: '/core/directives/user-action-card/user-action-card.html?$$REVISION$$',
    controller: UserActionCardController
  }
}

export { userActionCard }
